import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import auditedActionService from '@/modules/auditModule/services/AuditedActionService'
import { Nullable } from '@/shared/types/app.types'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { isNil, omitBy } from 'lodash'

export class AuditDatasource<T> extends PaginatorDatasource<T> {
    private readonly _externalFilterModel: Nullable<CommonFilterModel>

    constructor(externalFilterModel?: CommonFilterModel) {
        super(auditedActionService)
        this._externalFilterModel = omitBy(externalFilterModel, isNil)
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        const _filterModel =
            this._externalFilterModel
                ? Object.assign(filterModel, this._externalFilterModel)
                : filterModel
        return this.service.paginator(_filterModel, params)
    }
}
